<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronUpIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
